import { updateColumnsOnResize } from 'prosemirror-tables';
import { setCSSStyleDeclaration } from '../../../../utils/helper';
import { TABLE_BASE_STYLES } from '../../utils/editorStyles.constants';
export class TableView {
  constructor(node, cellMinWidth) {
    this.node = node;
    this.cellMinWidth = cellMinWidth;
    this.dom = document.createElement('div');
    this.dom.className = 'tableWrapper';
    this.table = this.dom.appendChild(document.createElement('table'));
    this.table.setAttribute('border', 1);
    setCSSStyleDeclaration(TABLE_BASE_STYLES.table, this.table);
    this.colgroup = this.table.appendChild(document.createElement('colgroup'));
    updateColumnsOnResize(node, this.colgroup, this.table, cellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement('tbody'));
  }
  update(node) {
    if (node.type !== this.node.type) {
      return false;
    }
    this.node = node;
    updateColumnsOnResize(node, this.colgroup, this.table, this.cellMinWidth);
    return true;
  }
  ignoreMutation(record) {
    return record.type === 'attributes' && (record.target === this.table || this.colgroup.contains(record.target));
  }
}
;